import { Component, OnInit } from "@angular/core";

@Component({
  styleUrls: ['../error.scss'],
  templateUrl: './403.component.html',
})
export class Error403Component {
  constructor() {
    
  }
}
